import Carousel from './Carousel';
import { CustomSlideType } from './Carousel.types';

export default Carousel;

export type { CustomSlideType };
